import { Label } from 'src/components/label';
import { SvgColor } from 'src/components/svg-color';

// ----------------------------------------------------------------------
const icon = (name: string) => (
  <SvgColor width="100%" height="100%" src={`/assets/icons/navbar/${name}.svg`} />
);

export const navData = [
  // {
  //   title: 'Dashboard',
  //   path: '/admin',
  //   icon: icon('ic-analytics'),
  // },
  {
    title: 'Quản lý công ty',
    path: '/admin/company',
    icon: icon('ic-user'),
  },
  {
    title: 'Tài khoản và quyền người dùng',
    path: 'user',
    icon: icon('ic-user'),
    children: [
      {
        title: 'Tài khoản',
        path: '/admin/account',
      },
      {
        title: 'Phân quyền người dùng',
        path: '/admin/permission',
      },
    ],
  },
  {
    title: 'Quản lý công thức tính',
    path: 'vcarbon',
    icon: icon('ic-user'),
    children: [
      {
        title: 'Công thức tính',
        path: '/admin/vcarbon-type',
      },
      {
        title: 'Quản lý danh mục tham số',
        path: '/admin/vcarbon',
      },
    ],
  },
  {
    title: 'Quản lý lĩnh vực kinh doanh',
    path: 'business',
    icon: icon('ic-user'),
    children: [
      {
        title: 'Lĩnh vực kinh doanh',
        path: '/admin/business-field-type',
      },
      {
        title: 'Cấu hình lĩnh vực',
        path: '/admin/business-field-define',
      },
    ],
  },

];


